import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateFilterData } from '#action/list-filter';
import { ResetButton } from './styles';

export const ResetAllButton = ({
  filters = [],
  relatedTo,
  showDateRange = false,
  onReset,
  label = 'RESET ALL'
}) => {
  const dispatch = useDispatch();

  const handleResetAll = useCallback(() => {
    filters.forEach(filter => {
      dispatch(updateFilterData([], filter.name, relatedTo));
    });

    if (showDateRange) {
      dispatch(updateFilterData(null, 'start', relatedTo));
      dispatch(updateFilterData(null, 'end', relatedTo));
    }

    if (onReset) {
      onReset();
    }
  }, [dispatch, filters, relatedTo, showDateRange, onReset]);

  return (
    <ResetButton
      onClick={handleResetAll}
      variant="text"
      size="small"
    >
      {label}
    </ResetButton>
  );
};
